'use client'

import { useState } from 'react';
import {
  KeyIcon,
  ExclamationCircleIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';
import { useRouter, useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';

import { Button } from '@/app/_ui/buttons/button';
import { montserrat } from '@/app/_ui/fonts';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';

export default function LoginForm() {

  const searchParams = useSearchParams();
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const router = useRouter();
  const callbackUrl = searchParams.get('callbackUrl') || '/dashboard';
  
  /* const [errorMessage, formAction, isLoading] = useFormState(
    authenticate,
    undefined,
  ); */

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const credentials = Object.fromEntries(formData.entries());

    setIsLoading(true);
    setErrorMessage("");

    const result = await signIn("credentials", {
      ...credentials,
      redirect: false, // para manejar resultado sin redirigir
    });

    if (result?.error) {
      if (result.error === "CredentialsSignin") {
        setErrorMessage("Usuario o contraseña incorrectos");
      } else {
        setErrorMessage(result.error);
      }
      setIsLoading(false);
    } else {
      // Redirigir al callbackUrl si el inicio de sesión fue exitoso
      router.push(callbackUrl);
    }
    
  };

  return (
    <>
    {/* <form action={formAction} className="space-y-3"> */}
    <form onSubmit={handleSubmit} className="space-y-3">
      <div className="flex-1 px-6 pb-4 pt-14 md:pt-8 md:rounded-lg md:shadow-md md:bg-gray-50">
        <h1 className={`${montserrat} mb-4 text-2xl text-center `}>
          Para continuar inicie sesión
        </h1>
        <div className="w-full">
          <div>
            <label
              className="mb-3 mt-5 block text-xs font-medium text-gray-900"
              htmlFor="usuario"
            >
              Usuario
            </label>
            <div className="relative">
              <input
                className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
                id="usuario"
                type="text"
                name="usuario"
                placeholder="Ingresa tu usuario"
                autoComplete='username'
                required
              />

              <UserCircleIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
            </div>
          </div>
          <div className="mt-4">
            <label
              className="mb-3 mt-5 block text-xs font-medium text-gray-900"
              htmlFor="clave"
            >
              Contraseña
            </label>
            <div className="relative flex">
              <KeyIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />

              {!showPassword ? 
                <>
                  <input
                    className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
                    id="clave"
                    type='password'
                    name="clave"
                    placeholder="Ingresa tu contraseña"
                    required
                    minLength={5}
                    autoComplete="current-password"
                  />
                  <EyeSlashIcon onClick={ handleShowPassword } className="absolute right-3 top-3 h-[18px] w-[18px] cursor-pointer text-gray-400 peer-focus:text-gray-700" />
                </>
                :
                <>
                  <input
                    className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
                    id="clave"
                    type='text'
                    name="clave"
                    placeholder="Ingresa tu contraseña"
                    required
                    minLength={5}
                    autoComplete="current-password"
                  />
                  <EyeIcon onClick={handleShowPassword} className="absolute right-3 top-3 h-[18px] w-[18px] cursor-pointer text-gray-400 peer-focus:text-gray-700" />
                </>
              }
            </div>
          </div>
        </div>

        <input type="hidden" name="redirectTo" value={callbackUrl} />

        <Button className="mt-8 md:mt-5 w-full justify-center text-center" aria-disabled={isLoading} >
          { isLoading ? 'Cargando...' : 'Iniciar sesión'}
        </Button>

        <div
          className="flex h-8 items-end space-x-1"
          aria-live="polite"
          aria-atomic="true"
        >
          {errorMessage !== "" && (
            <>
              <ExclamationCircleIcon className="h-5 w-5 text-terciary-400" />
              <p className="text-sm text-terciary-400">{errorMessage}</p>
            </>
          )}
        </div>
      </div>
    </form>
    </>
  );
}
